import { anchorInScopeChain, parseScopeChain, type ScopeAnchor } from '../../scope-chain.js';
import { scopesMatch } from '../../enrich-tag-scope.js';
import type { DbTagRow } from '../types.js';

export function refScopeChain(ref: DbTagRow): ScopeAnchor[] {
  const parsed = parseScopeChain(ref.scope_chain);
  if (parsed.length > 0) return parsed;
  if (ref.scope_start_line != null && ref.scope_start_column != null) {
    const chain: ScopeAnchor[] = [{ startLine: ref.scope_start_line, startColumn: ref.scope_start_column }];
    if (ref.parent_scope_start_line != null && ref.parent_scope_start_column != null) {
      chain.push({ startLine: ref.parent_scope_start_line, startColumn: ref.parent_scope_start_column });
    }
    return chain;
  }
  return [];
}

export function isModuleLevelDef(def: DbTagRow): boolean {
  return def.parent_scope_start_line == null && def.parent_scope_start_column == null;
}

export function defAtScopeAnchor(def: DbTagRow, anchor: ScopeAnchor): boolean {
  return (
    scopesMatch(def.scope_start_line, def.scope_start_column, anchor.startLine, anchor.startColumn) ||
    scopesMatch(def.start_line, def.start_column, anchor.startLine, anchor.startColumn)
  );
}

export function defVisibleInRefScopeChain(def: DbTagRow, ref: DbTagRow): boolean {
  const chain = refScopeChain(ref);
  if (chain.length === 0) return isModuleLevelDef(def);
  return (
    anchorInScopeChain(def.scope_start_line, def.scope_start_column, chain) ||
    anchorInScopeChain(def.start_line, def.start_column, chain.slice(1))
  );
}

export function scopeDepthInChain(def: DbTagRow, ref: DbTagRow): number {
  const chain = refScopeChain(ref);
  for (let index = 0; index < chain.length; index++) {
    const anchor = chain[index]!;
    if (defAtScopeAnchor(def, anchor)) return index;
  }
  return chain.length;
}
